
import React from 'react'

export default  React.createContext({
    open:false,
    event_id: 0,
    openEvent(id){},
    closeEvent(){}
});
